import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useMediaContext } from "@/context/MediaContext";
import { PRODUCTS } from "@/data/products";

const IG_URL = "https://instagram.com/reserve30parfums";
const SLOTS = ["instagram_1", "instagram_2", "instagram_3", "instagram_4", "instagram_5", "instagram_6"];
const DEFAULTS = [...PRODUCTS.map((p) => p.aestheticImage), ...PRODUCTS.map((p) => p.notesImage)].filter(Boolean).slice(0, 6);

export default function InstagramStrip() {
  const { media } = useMediaContext();
  const [live, setLive] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/instagram/feed`)
      .then((r) => r.json())
      .then((d) => setLive(Array.isArray(d.items) ? d.items.slice(0, 6) : []))
      .catch(() => setLive([]));
  }, []);

  const posts = live.length
    ? live.map((it, i) => ({ key: it.id, src: it.image_url, href: it.permalink || IG_URL, alt: it.caption || `Reserve 30 Instagram post ${i + 1}` }))
    : SLOTS.map((s, i) => ({ key: s, src: media[s] || DEFAULTS[i], href: IG_URL, alt: `Reserve 30 Instagram post ${i + 1}` })).filter((p) => p.src);
  if (posts.length === 0) return null;

  return (
    <section data-testid="instagram-strip" data-source={live.length ? "live" : "curated"} className="bg-[#EFE9E1] border-t border-black/10">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="overline-label">Social</p>
              <h2 className="font-serif-brand text-4xl md:text-5xl font-light mt-4">From our Instagram.</h2>
            </div>
            <a href={IG_URL} target="_blank" rel="noreferrer" data-testid="instagram-follow-link" className="btn-ghost-ink flex items-center gap-2">
              <Instagram size={14} strokeWidth={1.5} /> Follow @reserve30parfums
            </a>
          </div>
        </Reveal>
        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 md:gap-3">
          {posts.map((p, i) => (
            <Reveal key={p.key} delay={i * 0.06}>
              <a href={p.href} target="_blank" rel="noreferrer" data-testid={`instagram-post-${p.key}`} className="group block aspect-square overflow-hidden bg-[#F7F3EE]">
                <img src={p.src} alt={p.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
